import { useEffect } from "react";

// iOS Safari (<= 16) and some Chrome Android builds ignore the `muted` and
// `playsinline` values set as React properties and demand the HTML attributes
// on the element itself. Anything that expects to autoplay must call this
// with a ref to the <video>. Also mirrors `autoplay` for good measure.
//
// Usage:
//   const ref = useRef(null);
//   useIosSafeVideo(ref);
//   <video ref={ref} muted playsInline autoPlay ... />
export default function useIosSafeVideo(ref) {
  useEffect(() => {
    const v = ref?.current;
    if (!v) return;
    v.muted = true;
    v.setAttribute("muted", "");
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    v.setAttribute("autoplay", "");
  });
}
